import React from 'react';

import { Label, Link, Text } from 'Modules/ui2/components';

import styles from './index.module.scss';


export const Support = () => (
    <div className={styles.support}>
        <Label textSize='16' weight='demibold' component='h4'>
            Есть вопросы - мы готовы помочь!
        </Label>
        <Text component='p' textSize='14'>
            <strong>
                Служба технической поддержки
            </strong>
            <br />
            <Link href='https://support.factorin.io'>
                База знаний
            </Link>
        </Text>
        <Label component='div' textSize='16' className={styles.contacts}>
            <div>
                <Link href='tel:+74955323767'>
                    +7 (495) 532-3767
                </Link>
            </div>
            <div>
                <Link href='mailto:help@factorin.io'>
                    help@factorin.io
                </Link>
            </div>
        </Label>
    </div>
);
